import { Attribute, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

@JsonApiModelConfig({
    type: 'empresas'
})
export class Empresa extends JsonApiModel {
    @Attribute() nomeFantasia: string
    @Attribute() idExterno: string
    @Attribute() nome: string
    @Attribute() ativa: boolean

    get nomeComposto(): string {
        if (this.idExterno) {
            return `${this.idExterno} - ${this.nome}`
        }

        return this.nome
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/empresa.model.ts